import { useTranslation } from 'react-i18next';

/**
 * 效期状态徽章（UX §2 的统一语义，全系统只有这一套）。
 * "今天"以浏览器本地日期近似仓库本地日期——服务端判定（预警、FEFO）在 M8/M6
 * 按 warehouse.timezone 计算，这里只是展示层的即时提示。
 */
export function ExpiryBadge({
  expirationDate,
  hasExpiration,
}: {
  readonly expirationDate: string | null;
  readonly hasExpiration: boolean;
}): React.JSX.Element {
  const { t } = useTranslation();
  if (!hasExpiration || !expirationDate) {
    return <span className="badge badge--muted">{t('status.noExpiration')}</span>;
  }
  const today = new Date();
  const todayUtc = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  const [y, m, d] = expirationDate.split('-').map(Number);
  const expiry = Date.UTC(y!, m! - 1, d!);
  const days = Math.round((expiry - todayUtc) / 86_400_000);

  if (days < 0) {
    return (
      <span className="badge badge--danger">{t('status.expiredForDays', { count: -days })}</span>
    );
  }
  if (days === 0) {
    return <span className="badge badge--danger">{t('status.expiresToday')}</span>;
  }
  if (days <= 45) {
    return (
      <span className="badge badge--warning">{t('status.expiringInDays', { count: days })}</span>
    );
  }
  return <span className="badge badge--muted">{expirationDate}</span>;
}
